import moment from 'moment'
export default {
  methods: {
    isRefundExpire (time_stamp) {
      let lastTime = new Date(moment(new Date()).subtract(10, 'days').format('YYYY-MM-DD hh:mm:ss')).getTime()
      let curTime = new Date(time_stamp).getTime()
      if (curTime - lastTime > 0) {
        return false
      }
      return true
    }
  }
}
